export default __webpack_public_path__ + "static/media/store_intelligence-min.d864d3a7.png";